import { withDependencies, named } from '@wix/thunderbolt-ioc'
import type { TpaHandlerProvider } from '@wix/thunderbolt-symbols'
import { SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { TpaCommonsSiteConfig } from 'feature-tpa-commons'
import { name as tpaCommonsName } from 'feature-tpa-commons'

export type GetViewModeResponse = {
	editMode: TpaCommonsSiteConfig['viewMode']
}

export const GetViewModeHandler = withDependencies(
	[named(SiteFeatureConfigSymbol, tpaCommonsName)],
	(tpaCommonsSiteConfig: TpaCommonsSiteConfig): TpaHandlerProvider => ({
		getTpaHandlers() {
			return {
				getViewMode(): GetViewModeResponse {
					return {
						editMode: tpaCommonsSiteConfig.viewMode,
					}
				},
			}
		},
	})
)
